<template>
  <div class="container video-banner-with-title"
    :class="class_list">
    <div class="row video-banner-with-title_row">
      <div class="col-12 video-banner-with-title_vertical-stretch"
        :class="simple_text_aside ? 'col-sm-6' :  'col-sm-4'">
        <div class="video-banner-with-title_block">
          <default-title
            class="top_title"
            :title="top_title"
            title_tag="div"
          />
          <html-block
            v-if="top_sub_text"
            :content="top_sub_text"
          />
        </div>
        <div
          v-if="bottom_title"
          class="video-banner-with-title_block">
          <default-title
            class="bottom_title"
            :title="bottom_title"
            title_tag="div"
            white
          />
          <html-block
            v-if="bottom_sub_text"
            :content="getIsMobile && bottom_mobile_sub_text ? bottom_mobile_sub_text :bottom_sub_text"
          />
        </div>
      </div>
      <div class="col-12"
        :class="simple_text_aside ? 'col-sm-6' : 'col-sm-8'">
        <div class="h-100 position-relative">
          <video-preview-with-play-btn
            class="h-100"
            :image_src="image_src"
            :image_lazy_src="image_lazy_src"
            @click="video_shown = true"
          />
          <iframe
            v-if="video_shown"
            class="video-banner-with-title__video"
            width="100%"
            height="450"
            :src="get_src"
            title="YouTube video player" frameborder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope"
            allowfullscreen/>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import LazyImage from "../small_parts/LazyImage.vue";
import PlayVideoIcon from "../icons/PlayVideoIcon.vue";
import DefaultTitle from "../small_parts/DefaultTitle.vue";
import HtmlBlock from "../small_parts/HtmlBlock.vue";
import VideoPreviewWithPlayBtn from "../small_parts/VideoPreviewWithPlayBtn.vue";
import you_tube_video_mixin from "../../mixins/you_tube_video_mixin";
import {mapGetters} from "vuex";

export default {
  name: "VideoBannerWithTitleBlock",
  mixins: [you_tube_video_mixin],
  components: {
    VideoPreviewWithPlayBtn,
    HtmlBlock,
    DefaultTitle,
    PlayVideoIcon,
    LazyImage
  },
  props: {
    /**props**/
    top_title: {
      type: String,
      default: '',
      admin_type: 'input',
    },
    top_sub_text: {
      type: String,
      default: '',
      admin_type: 'editor',
    },
    bottom_title: {
      type: String,
      default: '',
      admin_type: 'input',
    },
    bottom_sub_text: {
      type: String,
      default: '',
      admin_type: 'editor',
    },
    bottom_mobile_sub_text: {
      type: String,
      default: '',
      admin_type: 'editor',
    },
    image_src: {
      type: String,
      required: true,
      admin_type: 'image',
    },
    image_lazy_src: {
      type: String,
      default: '',
      admin_type: 'image',
    },
    you_tube_src: {
      type: String,
      default: '',
      admin_type: 'input',
    },
    simple_text_aside: {
      type: Boolean,
      default: false,
      admin_type: 'checkbox',
    },
    mobile_green_banner: {
      type: Boolean,
      default: false,
      admin_type: 'checkbox',
    },
    /**props**/
  },
  computed: {
    ...mapGetters([
      'getIsMobile',
    ]),
    src() {
      return this.you_tube_src
    },
    class_list() {
      return {
        'content_bg-light': this.simple_text_aside,
        xs_green_banner: this.mobile_green_banner
      }
    }
  },
  data() {
    return {
      video_shown: false
    }
  },
}
</script>
